module.exports = __webpack_public_path__ + "img/volty_market_quadrado.03de72f1.png";